import EtchCopyBlockHeader from './EtchCopyBlockHeader.component';

export default EtchCopyBlockHeader;
